import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Charge, ChargeApi } from './charges.component';
import { Observable } from 'rxjs';
import { Material } from '../material/material';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';

@Injectable()
export class ChargeService {
    constructor(
        private readonly http: HttpClient,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    saveCharge(charge: Charge): Observable<Charge> {
        return this.http.post<Charge>(this.apiBaseUrl + 'charge/create.php', charge);
    }

    getChargesForMaterial(material: Material): Observable<ChargeApi> {
        const params = new HttpParams().set('artikel_id', material.artikel_id.toString());
        return this.http.get<ChargeApi>(this.apiBaseUrl + 'charge/read.php', { params: params });
    }
}
